<template>
  <div class="input-select-horizontal">
    <div class="slider" ref="sliderRef"></div>
    <div class="option" :ref="setOptionRef" v-for="(option, i) in options" :key="i" :class="{ selected: selected && option.value === selected.value }" @click="selectOption(i, $event)">{{ option.display }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, onMounted, onUpdated, onBeforeUpdate } from 'vue'

interface InputSelectOption {
  value: string | number;
  display: string | number;
}

export default defineComponent({
  name: 'InputSelectHorizontal',
  emits: ['update:modelValue', 'select'],
  props: {
    modelValue: [String, Number, Boolean] as PropType<string | number | null>,
    options: {
      type: Object as PropType<InputSelectOption[]>,
      required: true
    }
  },
  setup(props, { emit }) {
    const selected = ref<InputSelectOption | null>(null)
    const sliderRef = ref<HTMLElement | null>(null)
    let optionRefs: HTMLElement[] = []
    
    // Get template ref for each option
    onBeforeUpdate(() => optionRefs = [])
    function setOptionRef(el: HTMLElement) {
      optionRefs.push(el)
    }

    function updateSlider(el: HTMLElement) {       
      sliderRef.value && sliderRef.value.setAttribute('style', 'width:' + el.offsetWidth + 'px;' + 'transform: translateX(' + el.offsetLeft + 'px)')
    }


    function selectOption(i: number, evt: Event) {
      selected.value = props.options[i]
      emit('update:modelValue', props.options[i].value)
      emit('select', props.options[i].value)
      evt.target && updateSlider(evt.target as HTMLElement)
    }

    onMounted(() => {  
      const selectedIndex = props.options.findIndex(obj => obj.value === props.modelValue) || 0
      selected.value = props.options[selectedIndex]
      const el = optionRefs[selectedIndex]          
      el && updateSlider(el)
    })

    return { selectOption, selected, sliderRef, optionRefs, setOptionRef }
  }
})
</script>

<style scoped lang='scss'>
.input-select-horizontal {
  display: flex;
  position: relative;
  height: 2rem;
  overflow-x: auto;
  margin-left: 1rem;

  .slider {
    position: absolute;
    height: 100%;
    bottom: 0;
    z-index: -1;
    background: var(--color-primary);
    border-radius: 1rem;
    transition: transform .2s, width .2s;
  }
  .option {
    font-weight: 500;
    line-height: 2rem;
    padding: 0 .75rem;
    border-radius: 1rem;
    font-size: 15px;
    opacity: 0.7;
    transition: all .2s;
    cursor: pointer;
    white-space: nowrap;

    &.selected {
      opacity: 1;
      background: var(--color-primary);
      color: var(--color-on-primary);
    }
  }
}

</style>
